var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSmallWhiteCross(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{fill:none;stroke:#505050;stroke-width:2;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#505050;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#505050;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:#505050;stroke-width:3;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st6{fill:none;stroke:#FFFFFF;stroke-width:6;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_x5F_Action_x5F_01",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M16,9h22l8,8v32c0,1.1-0.9,2-2,2H16c-1.1,0-2-0.9-2-2V11C14,9.9,14.9,9,16,9z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "43,18 37,18 37,12  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M25,26.6v10.7c0,0.8,0.8,1.3,1.5,0.9l9.2-5.3c0.7-0.4,0.7-1.4,0-1.7l-9.2-5.3C25.8,25.4,25,25.8,25,26.6z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icon_x5F_Action_x5F_02",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M38.6,42.3L34.3,43l0.7-4.3l19.7-20.1c0.4-0.4,1.1-0.3,1.5,0.1l1.9,1.9c0.5,0.5,0.5,1.1,0.1,1.5L38.6,42.3z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 52,
    y1: 21.5,
    x2: 55.5,
    y2: 25
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "46,38 46,51 14,51 14,11 46,11 46,24  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 20,
    y1: 8,
    x2: 20,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 25,
    y1: 8,
    x2: 25,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 30,
    y1: 8,
    x2: 30,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 35,
    y1: 8,
    x2: 35,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 40,
    y1: 8,
    x2: 40,
    y2: 14
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Icon_x5F_Action_x5F_03",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M47,22H13v-6c0-1.1,0.9-2,2-2h30c1.1,0,2,0.9,2,2V22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M43,51H17c-1.1,0-2-0.9-2-2V22h30v27C45,50.1,44.1,51,43,51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M35,14H25v-3c0-1.1,0.9-2,2-2h6c1.1,0,2,0.9,2,2V14z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 23,
    y1: 27,
    x2: 23,
    y2: 46
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 30,
    y1: 27,
    x2: 30,
    y2: 46
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 37,
    y1: 27,
    x2: 37,
    y2: 46
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Icon_x5F_Action_x5F_04",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M402,216v-4c0-1.1-0.9-2-2-2h-20l-6,6v28c0,1.1,0.9,2,2,2h4"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "377,217 381,217 381,213  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M408,218h-20l-6,6v27c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2v-31C410,218.9,409.1,218,408,218z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "385,225 389,225 389,221  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M40,15v-4c0-1.1-0.9-2-2-2H18l-6,6v28c0,1.1,0.9,2,2,2h4"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "15,16 19,16 19,12  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M46,17H26l-6,6v27c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V19C48,17.9,47.1,17,46,17z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "23,24 27,24 27,20  "
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Icon_x5F_Action_x5F_05",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 30,
    cy: 10.5,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35,48.5c0,2.2-2.2,4-5,4s-5-1.8-5-4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M42,25.5c0-6.6-5.4-12-12-12s-12,5.4-12,12c0,6.1,0.2,9.2-1,13c-0.7,2.3-3,3.4-4,4c0,1.8,0,4,0,4h17h17 c0,0,0-2.3,0-4c-1-0.6-3.3-1.7-4-4C41.8,34.7,42,31.6,42,25.5z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Icon_x5F_Action_x5F_06",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M26,19.5V9c0-1.4-1.1-2.5-2.5-2.5l0,0C22.1,6.5,21,7.6,21,9v10.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M39,19.5V9c0-1.4-1.1-2.5-2.5-2.5l0,0C35.1,6.5,34,7.6,34,9v10.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 27,
    y1: 49.5,
    x2: 27,
    y2: 53.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M30,44.5c-6.4,0-11-3.6-11-9v-9l-4-3v-4h15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M30,19.5h15v4l-4,3v9c0,4.5-3.2,7.8-8,8.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 33,
    y1: 49.5,
    x2: 33,
    y2: 53.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M36,43.5v3c0,1.7-2.7,3-6,3s-6-1.3-6-3v-3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "31,30.5 32,24.5 24,33.5 29,33.5 28,39.5 36,30.5  "
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Icon_x5F_Action_x5F_07",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52,43.5c0,1.1-0.9,2-2,2H10c-1.1,0-2-0.9-2-2v-27c0-1.1,0.9-2,2-2h40c1.1,0,2,0.9,2,2V43.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49,17.5l-14,14c-2.7,2.7-7.2,2.7-9.9,0L11,17.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 11,
    y1: 42.5,
    x2: 22,
    y2: 31.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 49,
    y1: 42.5,
    x2: 38,
    y2: 31.5
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Icon_x5F_Action_x5F_08",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M31.1,40.3l-7.1,7c-2.3,2.3-6.1,2.3-8.5,0l-2.8-2.8c-2.3-2.3-2.3-6.1,0-8.5l10.6-10.6c2.3-2.3,6.1-2.3,8.5,0 l2.8,2.8c0.5,0.5,0.9,1.1,1.2,1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M28.9,19.8l7.1-7.1c2.3-2.3,6.1-2.3,8.5,0l2.8,2.8c2.3,2.3,2.3,6.1,0,8.5L36.7,34.6c-2.3,2.3-6.1,2.3-8.5,0 l-2.8-2.8c-0.5-0.5-0.9-1.1-1.2-1.6"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Icon_x5F_Action_x5F_09",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M42,46.5H10c-1.1,0-2-0.9-2-2v-21c0-1.1,0.9-2,2-2h32c1.1,0,2,0.9,2,2v21C44,45.6,43.1,46.5,42,46.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M12,19.5c0-1.1,0.9-2,2-2h32c1.1,0,2,0.9,2,2v21c0,1.1-0.9,2-2,2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M16,15.5c0-1.1,0.9-2,2-2h32c1.1,0,2,0.9,2,2v21c0,1.1-0.9,2-2,2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M41,24.5L30.2,35.3c-2.3,2.3-6.1,2.3-8.5,0L11,24.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 11,
    y1: 43.5,
    x2: 19,
    y2: 35.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 41,
    y1: 43.5,
    x2: 33,
    y2: 35.5
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Icon_x5F_Action_x5F_10",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18,37v2c0,0.8-0.7,1.4-1.5,1.6l-3,0.8C12.1,41.7,11,43,11,44v2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24,37v2c0,0.8,0.7,1.4,1.5,1.6l3,0.8C29.9,41.7,31,43,31,44v2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22,23c2.4,0,4,1.5,4,4v2l1,1v2l-1,1c0,0,0,1.8,0,2c0,2.1-4,3-5,3s-5-0.9-5-3c0-0.2,0-2,0-2l-1-1v-2l1-1v-2 c0-2.5,1.6-4,4-4H22z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 34,
    y1: 28,
    x2: 47,
    y2: 28
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 34,
    y1: 33,
    x2: 47,
    y2: 33
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 34,
    y1: 38,
    x2: 40,
    y2: 38
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "34,17 53,17 53,49 7,49 7,17 26,17  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 11,
    className: "st2",
    width: 8,
    height: 9
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Icon_x5F_Action_x5F_11",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "45,25 45,8 20,8 14,14 14,52 45,52 45,45  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "16,16 22,16 22,10  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M44,27c-10.5,0-14,8-14,8s3.5,8,14,8s14-8,14-8S54.5,27,44,27z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 44,
    cy: 35,
    r: 4
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Icon_x5F_Action_x5F_12",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "35,25 43,25 43,22 50,30 43,38 43,35 37,35  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 33,
    y1: 25,
    x2: 27,
    y2: 25
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 26,
    y1: 40,
    x2: 19,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 31,
    y1: 30,
    x2: 19,
    y2: 30
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 35,
    y1: 35,
    x2: 24,
    y2: 35
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "43,19 43,11 21,11 16,16 16,49 43,49 43,41  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "18,18 23,18 23,13  "
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Icon_x5F_Action_x5F_13",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M14,29V11c0-1.1,0.9-2,2-2h22l8,8v32c0,1.1-0.9,2-2,2H16c-1.1,0-2-0.9-2-2v-5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "43,18 37,18 37,12  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M35,44H10c-1.1,0-2-0.9-2-2V31c0-1.1,0.9-2,2-2h25c1.1,0,2,0.9,2,2v11C37,43.1,36.1,44,35,44z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6,40.3v-7.5H15c0.9,0,1.5,0,1.8,0.1c0.4,0.1,0.8,0.4,1.1,0.7s0.4,0.9,0.4,1.5c0,0.5-0.1,0.8-0.3,1.2s-0.4,0.6-0.6,0.7 s-0.5,0.3-0.8,0.4c-0.4,0.1-0.9,0.1-1.6,0.1h-1v2.8H12.6L12.6,40.3z M14.1,34.1v2.1h0.8c0.6,0,1,0,1.2-0.1 c0.2-0.1,0.4-0.2,0.5-0.4s0.2-0.4,0.2-0.6c0-0.3-0.1-0.5-0.2-0.7c-0.2-0.2-0.4-0.3-0.6-0.3c-0.2,0-0.5,0-1.1,0H14.1L14.1,34.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,32.8h2.8c0.6,0,1.1,0,1.4,0.1c0.4,0.1,0.8,0.4,1.1,0.7c0.3,0.3,0.5,0.7,0.7,1.2s0.3,1.1,0.3,1.8 c0,0.6-0.1,1.2-0.2,1.6c-0.2,0.5-0.5,1-0.8,1.3s-0.6,0.5-1.1,0.6c-0.3,0.1-0.8,0.2-1.3,0.2h-2.9V32.8L19.5,32.8z M21,34.1v5h1.1 c0.4,0,0.7,0,0.9-0.1c0.3-0.1,0.5-0.2,0.6-0.3s0.3-0.4,0.4-0.7s0.1-0.8,0.1-1.4c0-0.6,0-1-0.1-1.3s-0.3-0.5-0.4-0.7 c-0.2-0.2-0.4-0.3-0.7-0.3c-0.2,0-0.6-0.1-1.2-0.1L21,34.1L21,34.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1,40.3v-7.5h5.1v1.3h-3.6v1.8h3.1v1.3h-3.1v3.2L27.1,40.3L27.1,40.3z"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Icon_x5F_Action_x5F_14",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 30,
    cy: 37,
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32.3,32.6L30,27l-2.3,5.6C26.1,33.4,25,35.1,25,37c0,2.8,2.2,5,5,5s5-2.2,5-5C35,35.1,33.9,33.4,32.3,32.6z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 17,
    y1: 37,
    x2: 21,
    y2: 37
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 20.8,
    y1: 46.2,
    x2: 23.6,
    y2: 43.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 30,
    y1: 50,
    x2: 30,
    y2: 46
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 39.2,
    y1: 46.2,
    x2: 36.4,
    y2: 43.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 43,
    y1: 37,
    x2: 39,
    y2: 37
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 39.2,
    y1: 27.8,
    x2: 36.4,
    y2: 30.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 20.8,
    y1: 27.8,
    x2: 23.6,
    y2: 30.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M20,24v-7c0-5.5,4.5-10,10-10l0,0c5.5,0,10,4.5,10,10v7"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Icon_x5F_Action_x5F_15",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M30.1,50.2c0,0,0-1.1,0-2s-2.8-3.3-3.5-4.4c-0.4-0.7-3.5-9.4-3.5-9.4c0-1,2.5-2.2,4.1,0l2.6,4l1.3-1.3v-15 c0-1.1,0.9-2,2-2l0,0c1.1,0,2,0.9,2,2v13v-1v-5h2c0.6,0,1.6,0.4,2,1h2c0.9,0,2,0.9,2,2h2c0.9,0,2,0.9,2,2v10c0,2-2,3.7-2,5 s0,1,0,1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 39.1,
    y1: 30.2,
    x2: 39.1,
    y2: 35.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 43.1,
    y1: 32.2,
    x2: 43.1,
    y2: 36.2
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "47.1,53.2 47.1,50.2 28.1,50.2 28.1,53.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M29.1,29.6l-3-1.5l-7.5,3.7c-0.5,0.2-1-0.2-0.9-0.7l1.5-7.9L13,17.1c-0.4-0.4-0.1-1.1,0.4-1.1l8.4-0.8l3.7-8 c0.2-0.5,1-0.5,1.2,0l3.7,8l8.4,0.8c0.5,0,0.8,0.7,0.4,1.1l-2,2"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Icon_x5F_Action_x5F_16",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M31,10.6c-17.4-1-27.3,19.8-15.7,32.7c7.2,8.1,19.6,8.8,27.7,1.5c7.9-7.1,8.8-19.2,1.8-27.4l5-4l-14.5-3.3v15 l5-4c5.1,5.8,4.4,14.4-1.2,19.4c-5.7,5.1-14.4,4.6-19.5-1.1c-8.2-9.1-1.2-23.6,11-23"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Icon_x5F_Action_x5F_17",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M45,53v-4c0-1.1-0.9-2-2-2h-2v-8l-9-9l9-9v-8h2c1.1,0,2-0.9,2-2V7H15v4c0,1.1,0.9,2,2,2h2v8l9,9l-9,9v8h-2 c-1.1,0-2,0.9-2,2v4H45z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 19,
    y1: 13,
    x2: 41,
    y2: 13
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 19,
    y1: 47,
    x2: 41,
    y2: 47
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "37,47 37,41 31,35 29,35 23,41 23,47  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "22,15 22,19 28,25  "
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Icon_x5F_Action_x5F_18",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M39.7,48.7L39.7,48.7c-2.3-1.6-5.5-0.6-6.4,2l0,0c-0.3,0.9-1.5,1-2,0.2l0,0c-1.4-2.4-4.7-2.8-6.7-0.8l0,0 c-0.6,0.7-1.8,0.3-1.9-0.6l0,0c-0.4-2.8-3.2-4.4-5.8-3.4l0,0c-0.9,0.3-1.8-0.5-1.5-1.4l0,0c0.8-2.7-1.1-5.4-3.9-5.5l0,0 c-0.9,0-1.4-1.1-0.8-1.8l0,0c1.8-2.1,1.1-5.3-1.4-6.6l0,0c-0.8-0.4-0.8-1.6,0-2l0,0c2.5-1.2,3.2-4.4,1.4-6.6l0,0 c-0.6-0.7-0.1-1.8,0.8-1.8l0,0c2.8-0.1,4.7-2.7,4-5.4l0,0c-0.3-0.9,0.6-1.7,1.5-1.3l0,0c2.6,1.1,5.4-0.6,5.8-3.3l0,0 c0.1-0.9,1.3-1.3,1.9-0.6l0,0c1.9,2,5.2,1.7,6.7-0.6l0,0c0.5-0.8,1.7-0.7,2,0.2l0,0c0.9,2.6,4,3.7,6.3,2.1l0,0 c0.8-0.5,1.8,0.1,1.7,1l0,0c-0.2,2.8,2.2,5,4.9,4.5l0,0c0.9-0.2,1.6,0.8,1.2,1.6l0,0c-1.3,2.4,0,5.5,2.7,6.1l0,0 c0.9,0.2,1.2,1.4,0.4,2l0,0c-2.2,1.7-2.3,5-0.1,6.7l0,0c0.7,0.6,0.5,1.8-0.4,2l0,0c-2.7,0.6-4.1,3.7-2.8,6.1l0,0 c0.4,0.8-0.3,1.8-1.2,1.6l0,0c-2.7-0.5-5.2,1.7-5,4.5l0,0C41.5,48.6,40.4,49.2,39.7,48.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 30,
    cy: 30,
    r: 14
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "25,30 29,34 36,25  "
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Icon_x5F_Action_x5F_19",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M15,30v-3c0-1.1,0.9-2,2-2h26c1.1,0,2,0.9,2,2v22c0,1.1-0.9,2-2,2H17c-1.1,0-2-0.9-2-2v-2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M20,25v-8c0-5.5,4.5-10,10-10l0,0c5.5,0,10,4.5,10,10v8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M30,36H17.7c-1-2.4-3.3-4-6.1-4C7.9,32,5,34.8,5,38.4C5,42,7.9,45,11.6,45c2.3,0,4.3-1.2,5.5-3h3l1-1l1,1h3 l1-1h2l1,1h1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 10,
    y1: 37,
    x2: 10,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 30,
    y1: 34,
    x2: 30,
    y2: 44
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Icon_x5F_Action_x5F_20",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M41,18H14c-1.7,0-3,1.3-3,3v22c0,1.7,1.4,3,3.1,3h33.1c1.7,0,2.9-1.4,2.9-3V33"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 11,
    y1: 24,
    x2: 36,
    y2: 24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 11,
    y1: 30,
    x2: 30,
    y2: 30
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M28.3,40.7c0,0,6.3-2,7.9-3.6l19.7-19.7c1.6-1.6,1.5-2.8,0-4.2c-1.5-1.5-2.7-1.6-4.2,0L32,32.9 C30.4,34.5,28.3,40.7,28.3,40.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.8,16l5.7,5.7c0.8,0.8,0.8,2,0,2.8L46.1,33"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Icon_x5F_Action_x5F_21",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "39,53 31,45 35,41 39,45 50,34 54,38  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52,32V20c0-1.7-1.3-3-2.9-3h-37C10.4,17,9,18.3,9,20v24c0,1.7,1.4,3,3.1,3H28"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 9,
    y1: 23,
    x2: 52,
    y2: 23
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 9,
    y1: 29,
    x2: 52,
    y2: 29
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 12,
    y1: 33,
    x2: 19,
    y2: 33
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Icon_x5F_Action_x5F_22",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M16,9h22l8,8v32c0,1.1-0.9,2-2,2H16c-1.1,0-2-0.9-2-2V11C14,9.9,14.9,9,16,9z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "43,18 37,18 37,12  "
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Icon_x5F_Action_x5F_23",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 14,
    y1: 16,
    x2: 14,
    y2: 37
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 46,
    y1: 16,
    x2: 46,
    y2: 37
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M34,40v-5l4-4c0.7-0.7,2-1.9,2-3v-4c0-2.1-1.8-4-4-4v6l-3,3c-0.6,0.6-1.1,1-2,1h-5c-2.5,0-5,1.8-5,5v5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M29,27c1.7,0,3-1.3,3-2.9V23c0-1.6-1.3-2.9-3-2.9s-3,1.3-3,2.9v1C26,25.6,27.3,27,29,27z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 25,
    y1: 35,
    x2: 25,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 10,
    y1: 40,
    x2: 50,
    y2: 40
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "46,40 46,53 14,53 14,40  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 44,
    className: "st2",
    width: 22,
    height: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10,7v5c0,2.2,1.8,4,4,4s4-1.8,4-4c0,2.2,1.8,4,4,4s4-1.8,4-4c0,2.2,1.8,4,4,4s4-1.8,4-4c0,2.2,1.8,4,4,4 s4-1.8,4-4c0,2.2,1.8,4,4,4s4-1.8,4-4V7H10z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 18,
    y1: 11,
    x2: 18,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 26,
    y1: 11,
    x2: 26,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 34,
    y1: 11,
    x2: 34,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 42,
    y1: 11,
    x2: 42,
    y2: 12
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Icon_x5F_Action_x5F_24",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "29.8,37.8 42.5,41.8 51.8,11.2 8.2,30.5 18.8,33.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "22.5,48.8 18.8,33.8 37.3,24.8  "
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_25"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 1.5,
    y1: 1.5,
    x2: 58.5,
    y2: 58.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 58.5,
    y1: 1.5,
    x2: 1.5,
    y2: 58.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSmallWhiteCross);
export default __webpack_public_path__ + "static/media/Icon_SmallWhiteCross.d9ce1d39c34d41ec4723d13c3eaed129.svg";
export { ForwardRef as ReactComponent };